import React, { Component } from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
const companyLogo = require("../../assets/icons/ibm_blacklogo.png");

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHome: true,
      isInspectr: false
    };
  }

  render() {
    return (
      <div className="inspectr-footer">
          <div className="footer-text">Copyright © 2022 IBM IoT Canada 
          </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// src/components/footer/Footer.js